/* Lithos — comportements des pages categorie.
   Tout degrade proprement sans JavaScript : les filtres sont des liens, la
   pagination reste en place, le sommaire n'apparait simplement pas. */
(function () {
  'use strict';

  /* ---------- sommaire du bloc editorial ---------- */
  function sommaire() {
    var zone = document.querySelector('.lcs-sommaire');
    var texte = document.querySelector('.lcs-texte');
    if (!zone || !texte) return;
    var titres = texte.querySelectorAll('h2');
    if (titres.length < 3) return;
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(titres, function (h, i) {
      if (!h.id) {
        h.id = 'lcs-' + (i + 1) + '-' + (h.textContent || '')
          .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      }
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      frag.appendChild(a);
    });
    zone.appendChild(frag);
    zone.hidden = false;
  }

  /* ---------- rail de filtres ---------- */
  function filtres() {
    var racine = document.getElementById('lithos-filtres');
    if (!racine) return;
    var groupes = racine.querySelectorAll('.lfi-groupe');

    var mobile = window.matchMedia('(max-width: 749px)');

    function fermerTout(sauf) {
      Array.prototype.forEach.call(groupes, function (g) {
        if (g !== sauf) g.open = false;
      });
    }

    function fermer(g) {
      g.open = false;
      var resume = g.querySelector('summary');
      if (resume) resume.focus();
    }

    /* Les groupes sont ouverts dans le balisage : sans JavaScript, tout reste
       lisible. En pastilles (mobile) la feuille ne doit pas s'ouvrir seule au
       chargement, et une seule a la fois. En rail (desktop) tout reste deplie. */
    function appliquerMode() {
      if (mobile.matches) fermerTout(null);
    }
    appliquerMode();
    if (mobile.addEventListener) mobile.addEventListener('change', appliquerMode);

    Array.prototype.forEach.call(groupes, function (g) {
      g.addEventListener('toggle', function () {
        if (!g.open || !mobile.matches) return;
        fermerTout(g);
        var champ = g.querySelector('.lfi-chercher');
        if (champ) champ.focus();
      });

      /* Le voile est le ::before du <details> : un clic dessus a pour cible le
         <details> lui-meme, jamais le resume ni le panneau. C'est la seule
         facon de le reconnaitre — et c'est ce qui manquait. La pastille passant
         SOUS le voile, elle devenait incliquable : le panneau ne se refermait
         qu'en choisissant une option, donc en filtrant pour rien. */
      g.addEventListener('click', function (e) {
        if (!g.open || !mobile.matches) return;
        if (e.target === g) fermer(g);
      });
    });

    Array.prototype.forEach.call(racine.querySelectorAll('.lfi-fermer'), function (bouton) {
      bouton.addEventListener('click', function () {
        var g = bouton.closest('.lfi-groupe');
        if (g) fermer(g);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !mobile.matches) return;
      Array.prototype.forEach.call(groupes, function (g) {
        if (g.open) fermer(g);
      });
    });

    Array.prototype.forEach.call(racine.querySelectorAll('.lfi-chercher'), function (champ) {
      var panneau = champ.closest('.lfi-panneau');
      var items = panneau.querySelectorAll('li');
      champ.addEventListener('input', function () {
        var q = champ.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        var vus = 0;
        Array.prototype.forEach.call(items, function (li) {
          var t = (li.textContent || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          var garde = q === '' || t.indexOf(q) !== -1;
          li.hidden = !garde;
          if (garde) vus++;
        });
        /* une recherche sans resultat laissait une liste vide et muette */
        var vide = panneau.querySelector('.lfi-vide');
        if (vus === 0 && !vide) {
          vide = document.createElement('p');
          vide.className = 'lfi-vide';
          vide.textContent = 'Aucune correspondance.';
          panneau.appendChild(vide);
        } else if (vide) {
          vide.hidden = vus !== 0;
        }
      });
    });
  }

  /* ---------- voir plus ---------- */
  function voirPlus() {
    var zone = document.querySelector('[data-lvp]');
    if (!zone) return;
    var bouton = zone.querySelector('[data-lvp-bouton]');
    var compteur = zone.querySelector('[data-lvp-vus]');
    var grille = document.getElementById('product-grid');
    if (!bouton || !grille) return;
    document.querySelector('.product-grid-container').classList.add('lvp-actif');

    bouton.addEventListener('click', function () {
      var suivant = bouton.getAttribute('data-suivant');
      if (!suivant) return;
      bouton.setAttribute('aria-busy', 'true');
      var libelle = bouton.textContent;
      bouton.textContent = 'Chargement…';

      fetch(suivant)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.getElementById('product-grid');
          if (!neuf) throw new Error('grille absente');
          var ajoutes = 0;
          Array.prototype.forEach.call(neuf.children, function (li) {
            if (li.classList.contains('lgr-encart-case')) return;
            grille.appendChild(document.importNode(li, true));
            ajoutes += 1;
          });
          if (compteur) {
            compteur.textContent = String(parseInt(compteur.textContent, 10) + ajoutes);
          }
          var bsuite = doc.querySelector('[data-lvp-bouton]');
          var url = bsuite ? bsuite.getAttribute('data-suivant') : '';
          if (url) {
            bouton.setAttribute('data-suivant', url);
            bouton.textContent = libelle;
            bouton.removeAttribute('aria-busy');
          } else {
            zone.removeChild(bouton);
          }
          var pag = doc.querySelector('.pagination-wrapper');
          var ancienne = document.querySelector('.pagination-wrapper');
          if (pag && ancienne) ancienne.replaceWith(document.importNode(pag, true));
        })
        .catch(function () {
          // le bouton redevient un simple relais vers la page suivante
          bouton.removeAttribute('aria-busy');
          bouton.textContent = libelle;
          window.location.href = suivant;
        });
    });
  }

  /* ---------- defilement des vignettes ---------- */
  function vignettes() {
    var zone = document.querySelector('.lpa');
    var liste = zone && zone.querySelector('.lpa-liste');
    if (!liste) return;

    function fleche(sens, libelle, chemin) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lpa-fleche lpa-fleche--' + sens;
      b.setAttribute('aria-label', libelle);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + chemin +
        '" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      zone.appendChild(b);
      return b;
    }
    var arriere = fleche('arriere', 'Voir les catégories précédentes', 'M15 5 L8 12 L15 19');
    var avant = fleche('avant', 'Voir les catégories suivantes', 'M9 5 L16 12 L9 19');

    function pas() { return Math.max(liste.clientWidth * 0.8, 200); }
    avant.addEventListener('click', function () { liste.scrollLeft += pas(); });
    arriere.addEventListener('click', function () { liste.scrollLeft -= pas(); });

    function etat() {
      var deborde = liste.scrollWidth - liste.clientWidth > 4;
      arriere.hidden = !deborde || liste.scrollLeft < 4;
      avant.hidden = !deborde || liste.scrollLeft > liste.scrollWidth - liste.clientWidth - 4;
    }
    liste.addEventListener('scroll', etat);
    window.addEventListener('resize', etat);
    etat();
    // les images arrivent apres : la largeur reelle n'est connue qu'ensuite
    window.addEventListener('load', etat);
  }

  /* ---------- calculateur de tour de poignet ---------- */
  function calculateur() {
    var zone = document.querySelector('[data-lca]');
    if (!zone) return;
    var mesure = zone.querySelector('[data-lca-mesure]');
    var porte = zone.querySelector('[data-lca-porte]');
    var sortie = zone.querySelector('[data-lca-sortie]');
    var TAILLES = [17, 18, 19];

    function maj() {
      var v = parseFloat(String(mesure.value).replace(',', '.'));
      if (!(v >= 10 && v <= 25)) {
        sortie.textContent = 'Entrez une mesure entre 10 et 25 cm.';
        return;
      }
      var cible = v + parseFloat(porte.value);
      var choix = null;
      TAILLES.forEach(function (t) { if (choix === null && t + 0.5 >= cible) choix = t; });
      if (choix === null) {
        sortie.innerHTML = 'Votre cible est de <strong>' + cible.toFixed(1).replace('.', ',') +
          ' cm</strong>. Nos bracelets montent jusqu\u2019à 19 cm : écrivez-nous avant de commander.';
        return;
      }
      sortie.innerHTML = 'Votre cible est de <strong>' + cible.toFixed(1).replace('.', ',') +
        ' cm</strong>. Visez un bracelet de <strong>' + choix +
        ' cm</strong> : l\u2019élastique absorbe encore un demi-centimètre.';
    }
    mesure.addEventListener('input', maj);
    porte.addEventListener('change', maj);
    maj();
  }

  /* ---------- selecteur besoin + taille de perle ---------- */
  function selecteur() {
    var zone = document.querySelector('[data-lse]');
    if (!zone) return;
    var base = zone.getAttribute('data-base');
    // le nom de l'article est porte par la section, pas ecrit en dur
    var nomUn = zone.getAttribute('data-nom-un') || 'article';
    var nomPl = zone.getAttribute('data-nom-pl') || 'articles';
    var sBesoin = zone.querySelector('[data-lse-besoin]');
    var sDiam = zone.querySelector('[data-lse-diam]');
    var compte = zone.querySelector('[data-lse-compte]');
    var apercu = zone.querySelector('[data-lse-apercu]');
    var bouton = zone.querySelector('[data-lse-bouton]');
    var requete = 0;

    function cible() {
      var t = [];
      if (sDiam.value) t.push(sDiam.value);
      if (sBesoin.value) t.push(sBesoin.value);
      return t.length ? base + '/' + t.join('+') : base;
    }

    function maj() {
      var url = cible();
      bouton.href = url;
      // le robots.txt de Shopify interdit /collections/*+* : on ne transmet pas
      // de popularite vers une page que Google ne pourra pas explorer
      if (url.indexOf('+') > -1) {
        bouton.setAttribute('rel', 'nofollow');
      } else {
        bouton.removeAttribute('rel');
      }
      zone.setAttribute('data-chargement', '1');
      var mien = ++requete;

      // surtout pas d'en-tete Accept: application/json — Shopify sert alors sa
      // propre representation JSON de la collection et ignore le gabarit
      fetch(url + '?view=vignettes')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          if (mien !== requete) return;
          zone.removeAttribute('data-chargement');
          var n = d.total || 0;
          compte.textContent = n === 0
            ? 'Rien ne réunit ces deux critères. Essayez un autre choix.'
            : (n === 1 ? '1 ' + nomUn + ' correspond.' : n + ' ' + nomPl + ' correspondent.');
          apercu.innerHTML = '';
          (d.produits || []).forEach(function (p) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = p.url;
            var img = document.createElement('img');
            img.src = p.image; img.alt = p.alt || ''; img.loading = 'lazy';
            var nom = document.createElement('span');
            nom.className = 'lse-apercu-nom'; nom.textContent = p.titre;
            var prix = document.createElement('span');
            prix.className = 'lse-apercu-prix'; prix.textContent = p.prix;
            a.appendChild(img); a.appendChild(nom); a.appendChild(prix);
            li.appendChild(a); apercu.appendChild(li);
          });
          bouton.hidden = n === 0;
        })
        .catch(function () {
          if (mien !== requete) return;
          zone.removeAttribute('data-chargement');
          // le bouton reste un lien valide : la page filtrée existe sans JavaScript
          apercu.innerHTML = '';
          compte.textContent = 'Voir les ' + nomPl + ' qui correspondent.';
          bouton.hidden = false;
        });
    }
    sBesoin.addEventListener('change', maj);
    sDiam.addEventListener('change', maj);
    maj();
  }


  // ----------------------------------------------------- a quel poignet le porter
  // La convention de lithotherapie : a gauche on recoit, a droite on emet. Le
  // confort veut le bracelet a la main qui n'ecrit pas. Quand les deux se
  // contredisent, on le dit au lieu de trancher a la place du client.
  function poignetDePort() {
    var zone = document.querySelector('[data-lmn]');
    if (!zone) return;
    var sIntention = zone.querySelector('[data-lmn-intention]');
    var sMain = zone.querySelector('[data-lmn-main]');
    var reponse = zone.querySelector('[data-lmn-reponse]');
    var pourquoi = zone.querySelector('[data-lmn-pourquoi]');
    if (!sIntention || !sMain || !reponse) return;

    function maj() {
      var recevoir = sIntention.value === 'recevoir';
      var cote = recevoir ? 'gauche' : 'droite';
      var libre = sMain.value === 'droite' ? 'gauche' : 'droite';
      // « poignet » est masculin : droit, et non droite
      var nom = cote === 'droite' ? 'droit' : 'gauche';
      reponse.textContent = 'Poignet ' + nom + '.';
      if (cote === libre) {
        pourquoi.textContent = recevoir
          ? 'La tradition place à gauche ce que l’on veut recevoir, et c’est aussi votre main libre : le bracelet ne frottera pas quand vous écrivez.'
          : 'La tradition place à droite ce que l’on veut émettre, et c’est aussi votre main libre : rien ne gêne votre geste.';
      } else {
        pourquoi.textContent = 'La tradition le place à ' + cote + ', mais c’est votre main d’écriture. Si le bracelet gêne, portez-le à '
          + libre + ' : le confort passe devant la convention.';
      }
    }
    sIntention.addEventListener('change', maj);
    sMain.addEventListener('change', maj);
    maj();
  }

  function demarrer() { sommaire(); filtres(); voirPlus(); vignettes(); calculateur(); selecteur(); poignetDePort(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
